import React from 'react'

const LocationSvg = () => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
<path d="M26.6663 13.3327C26.6663 19.99 19.281 26.9233 16.801 29.0647C16.57 29.2384 16.2887 29.3323 15.9997 29.3323C15.7106 29.3323 15.4294 29.2384 15.1983 29.0647C12.7183 26.9233 5.33301 19.99 5.33301 13.3327C5.33301 10.5037 6.45681 7.7906 8.4572 5.79021C10.4576 3.78982 13.1707 2.66602 15.9997 2.66602C18.8287 2.66602 21.5418 3.78982 23.5421 5.79021C25.5425 7.7906 26.6663 10.5037 26.6663 13.3327Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M16 17.334C18.2091 17.334 20 15.5431 20 13.334C20 11.1248 18.2091 9.33398 16 9.33398C13.7909 9.33398 12 11.1248 12 13.334C12 15.5431 13.7909 17.334 16 17.334Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  )
}

export default LocationSvg